import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { OPTIONS_PROPS } from 'ui/components/nav/Dropdown/Dropdown';

dayjs.extend(utc);
dayjs.extend(timezone);
// dayjs.tz.setDefault(import.meta.env.VITE_APP_TIMEZONE);

export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT_V2 = 'DD MMM YYYY';
export const TIME_FORMAT = 'hh:mm A';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm a';

export const OTP_EXPIRY = 160;

export const MAX_UPLOAD_SIZE = 1024 * 1024 * 15;

export const SMS_EXTRA_CHARGE = 0.3;

export enum INDUSTRIES {
  aerospace = 'Aerospace',
  transport = 'Transport',
  computer = 'Computer',
  telecommunication = 'Telecommunication',
  agriculture = 'Agriculture',
  construction = 'Construction',
  education = 'Education',
  pharmaceutical = 'Pharmaceutical',
  food = 'Food',
  healthCare = 'Health Care',
  hospitality = 'Hospitality',
  entertainment = 'Entertainment',
  newsMedia = 'News Media',
  energy = 'Energy',
  manufacturing = 'Manufacturing',
  music = 'Music',
  mining = 'Mining',
  worldwideWeb = 'Worldwide Web',
  electronics = 'Electronics',
}

export enum COMPANY_TYPES {
  soleProprietorship = 'Sole Proprietorship',
  corporation = 'Corporation',
  llc = 'Limited Liability Company',
  partnership = 'Partnership',
  jointVenture = 'Joint Venture',
  nonProfit = 'Non Profit',
}

export enum DEAL_TYPES {
  NEW_BUSINESS = 'New Business',
  EXISTING_BUSINESS = 'Existing Business',
}

export enum MFA_METHOD {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export const ACL_ACCESS_LEVEL_DEFAULT = ['ACCOUNT_USER', 'ACCOUNT_ADMIN'];

export enum NOTIFICATION_STATUSES {
  UNREAD = 'UNREAD',
  READ = 'READ',
}

export enum NOTIFICATION_TYPE {
  ACCOUNT = 'ACCOUNT',
  ADMIN = 'ADMIN',
}

export const INVOICE_VARIABLES = [
  '<ClientName>',
  '<DueAt>',
  '<CompanyName>',
  '<OrderNumber>',
  '<TotalAmount>',
  '<PaymentMethod>',
  '<PaidAt>',
  '<IssuedAt>',
  '<ReceiptUrl>',
];

export enum ROLE_MODULE {
  ACCOUNT = 'ACCOUNT',
  CHANNEL = 'CHANNEL',
  CONTACT = 'CONTACT',
  CALENDAR = 'CALENDAR',
  SALES = 'SALES',
  ANALYTICS = 'ANALYTICS',
  ROLE = 'ROLE',
  PLAN = 'PLAN',
  WEBHOOK = 'WEBHOOK',
  AUTOMATION = 'AUTOMATION',
  TAG = 'TAG',
  DATA = 'DATA',
  VIEW = 'VIEW',
  CAMPAIGN = 'CAMPAIGN',
}

export enum ROLES {
  account = 'account',
  admin = 'admin',
}

export const TIMES = [
  { label: '12:00 AM', value: '00:00' },
  { label: '12:15 AM', value: '00:15' },
  { label: '12:30 AM', value: '00:30' },
  { label: '12:45 AM', value: '00:45' },
  { label: '1:00 AM', value: '01:00' },
  { label: '1:15 AM', value: '01:15' },
  { label: '1:30 AM', value: '01:30' },
  { label: '1:45 AM', value: '01:45' },
  { label: '2:00 AM', value: '02:00' },
  { label: '2:15 AM', value: '02:15' },
  { label: '2:30 AM', value: '02:30' },
  { label: '2:45 AM', value: '02:45' },
  { label: '3:00 AM', value: '03:00' },
  { label: '3:15 AM', value: '03:15' },
  { label: '3:30 AM', value: '03:30' },
  { label: '3:45 AM', value: '03:45' },
  { label: '4:00 AM', value: '04:00' },
  { label: '4:15 AM', value: '04:15' },
  { label: '4:30 AM', value: '04:30' },
  { label: '4:45 AM', value: '04:45' },
  { label: '5:00 AM', value: '05:00' },
  { label: '5:15 AM', value: '05:15' },
  { label: '5:30 AM', value: '05:30' },
  { label: '5:45 AM', value: '05:45' },
  { label: '6:00 AM', value: '06:00' },
  { label: '6:15 AM', value: '06:15' },
  { label: '6:30 AM', value: '06:30' },
  { label: '6:45 AM', value: '06:45' },
  { label: '7:00 AM', value: '07:00' },
  { label: '7:15 AM', value: '07:15' },
  { label: '7:30 AM', value: '07:30' },
  { label: '7:45 AM', value: '07:45' },
  { label: '8:00 AM', value: '08:00' },
  { label: '8:15 AM', value: '08:15' },
  { label: '8:30 AM', value: '08:30' },
  { label: '8:45 AM', value: '08:45' },
  { label: '9:00 AM', value: '09:00' },
  { label: '9:15 AM', value: '09:15' },
  { label: '9:30 AM', value: '09:30' },
  { label: '9:45 AM', value: '09:45' },
  { label: '10:00 AM', value: '10:00' },
  { label: '10:15 AM', value: '10:15' },
  { label: '10:30 AM', value: '10:30' },
  { label: '10:45 AM', value: '10:45' },
  { label: '11:00 AM', value: '11:00' },
  { label: '11:15 AM', value: '11:15' },
  { label: '11:30 AM', value: '11:30' },
  { label: '11:45 AM', value: '11:45' },
  { label: '12:00 PM', value: '12:00' },
  { label: '12:15 PM', value: '12:15' },
  { label: '12:30 PM', value: '12:30' },
  { label: '12:45 PM', value: '12:45' },
  { label: '1:00 PM', value: '13:00' },
  { label: '1:15 PM', value: '13:15' },
  { label: '1:30 PM', value: '13:30' },
  { label: '1:45 PM', value: '13:45' },
  { label: '2:00 PM', value: '14:00' },
  { label: '2:15 PM', value: '14:15' },
  { label: '2:30 PM', value: '14:30' },
  { label: '2:45 PM', value: '14:45' },
  { label: '3:00 PM', value: '15:00' },
  { label: '3:15 PM', value: '15:15' },
  { label: '3:30 PM', value: '15:30' },
  { label: '3:45 PM', value: '15:45' },
  { label: '4:00 PM', value: '16:00' },
  { label: '4:15 PM', value: '16:15' },
  { label: '4:30 PM', value: '16:30' },
  { label: '4:45 PM', value: '16:45' },
  { label: '5:00 PM', value: '17:00' },
  { label: '5:15 PM', value: '17:15' },
  { label: '5:30 PM', value: '17:30' },
  { label: '5:45 PM', value: '17:45' },
  { label: '6:00 PM', value: '18:00' },
  { label: '6:15 PM', value: '18:15' },
  { label: '6:30 PM', value: '18:30' },
  { label: '6:45 PM', value: '18:45' },
  { label: '7:00 PM', value: '19:00' },
  { label: '7:15 PM', value: '19:15' },
  { label: '7:30 PM', value: '19:30' },
  { label: '7:45 PM', value: '19:45' },
  { label: '8:00 PM', value: '20:00' },
  { label: '8:15 PM', value: '20:15' },
  { label: '8:30 PM', value: '20:30' },
  { label: '8:45 PM', value: '20:45' },
  { label: '9:00 PM', value: '21:00' },
  { label: '9:15 PM', value: '21:15' },
  { label: '9:30 PM', value: '21:30' },
  { label: '9:45 PM', value: '21:45' },
  { label: '10:00 PM', value: '22:00' },
  { label: '10:15 PM', value: '22:15' },
  { label: '10:30 PM', value: '22:30' },
  { label: '10:45 PM', value: '22:45' },
  { label: '11:00 PM', value: '23:00' },
  { label: '11:15 PM', value: '23:15' },
  { label: '11:30 PM', value: '23:30' },
  { label: '11:45 PM', value: '23:45' },
];

export enum STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SUBSCRIPTION_STATUS {
  TRIAL = 'Free Trial',
  PAID = 'Subscribed',
  EXPIRED = 'Cancelled',
}

export enum ACCESS_LEVEL {
  ACCOUNT_USER = 'ACCOUNT_USER',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
}

export enum ACTIONS {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum FEATURE_FLAG_KEYS {
  HELP_MODULE = 'help-module',
  SMS_MODULE = 'sms-module',
  EMAIL_MODULE = 'email-module',
  CALL_MODULE = 'call-module',
  AUTOMATION_MODULE = 'automation-module',
  TOAD_MODULE = 'toad-module',
  WEBSITE_BUILDER_MODULE = 'website-builder-module',
  ACTIVE_AGENT_MODULE = 'active-agent-module',
}

export enum PERMISSION_KEYS {
  ACCOUNT = 'account-accounts',
  SMS = 'channel-sms',
  ACCOUNT_STATUS = 'account-status',
  ACCOUNT_INVOICE = 'account-invoice',
  PIPELINES = 'sales-pipelines',
  LEADS = 'contact-leads',
  BOOKINGS = 'calendar-bookings',
  DEALS = 'sales-deals',
  STAGES = 'sales-stages',
  TASKS = 'sales-tasks',
  COMPANIES = 'contact-companies',
  EVENTS = 'calendar-events',
  ANALYTICS = 'analytics-analytics',
  DASHBOARD = 'analytics-dashboard',
  ORDERS = 'sales-orders',
  PRODUCTS = 'sales-products',
  FIELDS = 'field-fields',
  ROLES = 'role-roles',
  PERMISSIONS = 'role-permissions',
  PLAN = 'plan-plans',
  WEBHOOKS = 'webhook-webhooks',
  TOKENS = 'webhook-tokens',
  AUTOMATION = 'automation-automations',
  TAG = 'tag-tags',
  DATA = 'data-data',
  VIEW_DATA = 'view-data',
  VIEW_DATA_TABLE = 'view-data-table',
  VIEW_DATA_FORM = 'view-data-form',
  VIEW_DATA_INFO_PAGE = 'view-data-info-page',
  ACTIVE_AGENTS = 'channel-active-agents',
  CAMPAIGNS = 'campaign-campaigns',
}

export const ACCOUNT_USER = 'ACCOUNT_USER';

export enum POSITION {
  Center = 'center',
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
}

export enum SIZE {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

export enum ACCOUNT_SETTINGS_KEY {
  Account = 'account-settings',
  Calendar = 'calendar-settings',
  Notification = 'notification-settings',
}

export enum COMPOSER_TYPES {
  email = 'email',
  sms = 'sms',
  note = 'note',
  call = 'call',
  deal = 'deal',
  task = 'task',
  event = 'event',
  field = 'field',
}

export enum COMPOSER_MODES {
  popover = 'popover',
  modal = 'modal',
}

export const OTP_LENGTH = 4;

export const DATE_OPTIONS = [
  {
    value: JSON.stringify({
      $gte: dayjs.tz().startOf('day').toDate(),
      $lt: dayjs.tz().endOf('day').toDate(),
    }),
    label: 'Today',
    description: 'Today from midnight until the current time',
  },
  {
    value: JSON.stringify({
      $gte: dayjs.tz().subtract(1, 'd').startOf('day').toDate(),
      $lt: dayjs.tz().subtract(1, 'd').endOf('day').toDate(),
    }),
    label: 'Yesterday',
    description: 'The previous 24 hours day',
  },
  {
    value: JSON.stringify({
      $gte: dayjs.tz().startOf('week').toDate(),
      $lt: dayjs.tz().endOf('week').toDate(),
    }),
    label: 'This week',
    description: 'The current calendar week',
  },
  {
    value: JSON.stringify({
      $gte: dayjs.tz().startOf('month').toDate(),
      $lt: dayjs.tz().endOf('month').toDate(),
    }),
    label: 'This month',
    description: 'The current calendar month',
  },
];

export const DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export enum HttpStatus {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

export enum ProductType {
  Amount = 'AMOUNT',
  Hourly = 'HOURLY',
  Quantity = 'QUANTITY',
}

export enum INVOICE_TERMS {
  OneTime = 'ONE_TIME',
  Monthly = 'MONTHLY',
  Annually = 'ANNUALLY',
}

export enum INVOICE_STATUS {
  DRAFT = 'DRAFT',
  UNSENT = 'UNSENT',
  SENT = 'SENT',
  SKIP = 'SKIP',
  OVERDUE = 'OVERDUE',
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
}

export enum ORDER_STATUS {
  APPROVED = 'APPROVED',
  ACTIVE = 'ACTIVE',
  PAID = 'PAID',
}

export enum EVENT_TYPES {
  EVENT = 'EVENT',
  VIDEO = 'VIDEO',
  CALL = 'CALL',
  BOOKING = 'BOOKING',
  MEETING = 'MEETING',
}

export enum EVENT_TABS {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export enum STATUS_TYPE {
  Progress = 'progress',
  Open = 'open',
  Success = 'success',
  OnGoing = 'on-going',
  Urgent = 'urgent',
  Cancelled = 'cancelled',
  Close = 'close',
  Warning = 'warning',
  Pending = 'pending',
  Delay = 'delay',
  Default = 'default',
}

export const DEMO_ACCOUNT_USER = {
  photoUrl: '',
  itemLabel: 'Jane Doe',
  description: 'sample@admin.com',
  value: 'test-admin',
};

export const DEMO_CONTACT = {
  photoUrl: '',
  itemLabel: 'John Doe',
  description: 'sample@user.com',
  value: 'test-user',
};

export const DEMO_EVENT = {
  accountId: DEMO_CONTACT.value,
  type: EVENT_TYPES.CALL,
  startAt: dayjs().startOf('day').toDate(),
  _id: 'test-event',
  endAt: dayjs().startOf('day').add(15, 'minutes').toDate(),
  id: 'test-event',
  title: 'Sample Event',
  notifyBefore: 5,
  guests: [{ emailAddress: 'john@doe.com' }],
};

export const DEMO_BOOKING = {
  status: STATUS.ACTIVE,
  title: 'Demo Booking',
  id: 'test-booking',
  _id: 'test-booking',
  duration: 30,
  eventUrl: 'https://meet.google.com/riv-nnjx-dcq',
  durationType: 'minutes',
  notifyBefore: 5,
};

export const AVATAR_COLORS = [
  'bg-content',
  'bg-[#23CC67]',
  'bg-[#A7EBC2]',
  'bg-[#4A545E]',
  'bg-[#9EA8B3]',
  'bg-[#1973E8]',
  'bg-[#A3C7F6]',
  'bg-[#ED6400]',
  'bg-[#EC8C48]',
  'bg-[#E22323]',
  'bg-[#F1A3A3]',
  'bg-[#FFAB26]',
  'bg-[#FFC76E]',
  'bg-[#06E6BF]',
  'bg-[#9FF4E5]',
];

export enum ACCOUNT_STATUS_SOURCE {
  LEAD = 'LEAD',
}

export const LEAD_ASSIGNMENT_TYPE = [
  { label: 'Round Robin', value: 'ROUND_ROBIN' },
  { label: 'Least Load', value: 'LEAST_LOAD' },
  { label: 'Default Lead', value: 'ASSIGNED' },
] as OPTIONS_PROPS[];

export enum CHAT_ROLE {
  Assistant = 'assistant',
  User = 'user',
  System = 'system',
}

export const TASK_PRIORITY = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
];

export const PREMIUM_MESSAGE = `Subscribe to unlock this feature.
  This feature is available with a Leapify Premium plan.`;

export default {
  PREMIUM_MESSAGE,
  OTP_EXPIRY,
  DATE_FORMAT,
  DATE_FORMAT_V2,
  TIME_FORMAT,
  DATE_TIME_FORMAT,
  DEAL_TYPES,
  INDUSTRIES,
  COMPANY_TYPES,
  NOTIFICATION_STATUSES,
  MFA_METHOD,
  MAX_UPLOAD_SIZE,
  INVOICE_VARIABLES,
  TIMES,
  STATUS,
  ROLES,
  SUBSCRIPTION_STATUS,
  ACL_ACCESS_LEVEL_DEFAULT,
  PERMISSION_KEYS,
  FEATURE_FLAG_KEYS,
  ACTIONS,
  ACCESS_LEVEL,
  ACCOUNT_USER,
  POSITION,
  SIZE,
  COMPOSER_TYPES,
  OTP_LENGTH,
  INVOICE_TERMS,
  INVOICE_STATUS,
};

export enum CAMPAIGN_STATUS_TYPE {
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMEPLTED = 'COMEPLTED',
}

export enum CAMPAIGN_MESSAGE_STATUS_TYPE {
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}
